<template>
  <div>
    <span v-for="option in options" :key="option" class="option" :class="[{ active: cover === option }, `option--${option}`]" @click.stop.prevent="update(option)"></span>
  </div>
</template>

<script>
  export default {
    props: ['cover'],
    
    data() {
      return {
        options: ['default', 'black']
      }
    },

    methods: {
      update(option) {
        this.$emit('update:cover', option);
      }
    }
  }
</script>

<style scoped>
  .option.active:before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 1px solid #000;
  }

  .option {
    position: relative;
    display: inline-block;

    height: 1em;
    width: 1em;
    margin: 2px;
    border: 1px solid #fff;

    margin-right: 0.35em;
  }

  .option--default {
    background-image: url('~@/assets/cloud.jpg');
    background-size: cover;
  }

  .option--black {
    background: rgb(0, 0, 0);
  }
</style>